import React, { Fragment } from "react"

import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Skeleton,
  Slide,
  Typography,
} from "@mui/material"

import {
  Close as CloseIcon,
  Language as LanguageIcon,
  LocalPhone as LocalPhoneIcon,
  Map as MapIcon,
  MenuBookTwoTone as MenuBookIcon,
  PeopleAlt as PeopleAltIcon,
} from "@mui/icons-material"

import * as styles from "./Card.module.scss"


const CardComponent = ({ enabled, container, data, setData }) => {
  function clanData(field) {
    return data === null ? <Skeleton /> : data[field];
  }

	return (
		<Slide
			direction="right"
			in={enabled}
			container={container}
		>
			<Card
				sx={{
					minWidth: [125, 200, 275, 350],
					maxWidth: [180, 280, 375, 475],
				}}
				className={data ? styles.infoCardActive : styles.infoCard}
			>

				<CardContent>
					<CloseIcon onClick={() => setData(null)} />

					<Box sx={{ py: 1, px: 1.5 }}>

						<Typography color="text.secondary" variant="subtitle2">
							{clanData("cchypy")}
						</Typography>

						<Typography variant="h5">
							{clanData("ccchi")}
						</Typography>

						<Typography variant="subtitle1">
							{clanData("cceng")}
						</Typography>

						<Typography variant="overline" gutterBottom>
							Established in {clanData("yearest")}
						</Typography>

						<Divider />

						<Grid container alignItems="start" rowSpacing={2} my={2}>

							<Grid item xs={2}>
								<LocalPhoneIcon color="primary" />
							</Grid>
							<Grid item xs={10}>
								<Typography variant="body2">
									{clanData("phone")}
								</Typography>
							</Grid>

							<Grid item xs={2}>
								<MapIcon color="primary" />
							</Grid>
							<Grid item xs={10}>
								<Typography variant="body2">
									{clanData("address")}
								</Typography>
							</Grid>

							{clanData("website") !== null && (
								<>
								<Grid item xs={2}>
									<LanguageIcon color="primary" />
								</Grid>

								<Grid item xs={10}>
									{Array.isArray(clanData("website")) && clanData("website").map(url =>
										<a
											href={url.startsWith("http") ? url : "http://" + url}
											key={url}
											target="_blank"
											rel="noreferrer"
										>
											<Typography variant="body2">
												{url}
											</Typography>
										</a>
									)}
								</Grid>
								</>
							)}

							<Grid item xs={2}>
								<PeopleAltIcon color="primary" />
							</Grid>
							<Grid item xs={10}>
								<Typography variant="body2">
									{clanData("member")} members
								</Typography>
							</Grid>

						</Grid>

						<Divider />

						<Grid container alignItems="start" rowSpacing={2} my={2}>

							{Array.isArray(clanData("publications")) && clanData("publications").map((book, ind) => (
								<Fragment key={book.bibrec + ind}>

								<Grid item xs={2}>
									<MenuBookIcon color="primary" />
								</Grid>

								<Grid item xs={10}>
									<a href={book.lincurl}>
										<Typography variant="body2">
											{book.title}
										</Typography>
									</a>
								</Grid>

								</Fragment>
							))}

						</Grid>

					</Box>

				</CardContent>

			</Card>
		</Slide>
	)
}

export default CardComponent
